module.exports = __webpack_public_path__ + "static/media/TicketsOrdering.ad91d7bf.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/TicketsOrdering.svg
// module id = 2607
// module chunks = 0